import React from "react";
import PropTypes from "prop-types";

import CardDetail from "../../CardDetail";

export const ErrorCard = ({ type, description }) => (
  <CardDetail isCurrent type={type} description={description} />
);

ErrorCard.propTypes = {
  type: PropTypes.string,
  description: PropTypes.string
};

ErrorCard.defaultProps = {
  type: "JOURNEY_FINISHED_ABNORMALLY",
  description: "dropout_card-text_1"
};

export default ErrorCard;
